import { Box, Button, Typography } from "@mui/material";
import {
  SwapVert as SwapVertIcon,
  Delete as DeleteIcon,
  ArrowUpward,
  ArrowDownward,
} from "@mui/icons-material";

export const columns = ({
  handleEdit,
  handleDelete,
  sortBy,
  isDescending,
  setSortBy,
  setIsDescending,
}) => [
  {
    accessorKey: "name",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            setSortBy("name");
            setIsDescending(!isDescending);
          }}
        >
          {" "}
          <Typography variant="body2">Name</Typography>
          {sortBy === "name" ? (
            isDescending == false ? (
              <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
            ) : (
              <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
            )
          ) : (
            <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
          )}{" "}
        </div>
      </div>
    ),
    cell: ({ row, value }) => (
      <>
        <Box component="span" sx={{ marginLeft: 1 }}>
          {row.original.title}
        </Box>
      </>
    ),
  },
  {
    accessorKey: "type",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            setSortBy("type");
            setIsDescending(!isDescending);
          }}
        >
          {" "}
          <Typography variant="body2">Ad type</Typography>
          {sortBy === "type" ? (
            isDescending == false ? (
              <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
            ) : (
              <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
            )
          ) : (
            <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
          )}{" "}
        </div>
      </div>
    ),
    cell: ({ row, value }) => (
      <>
        <Box component="span" sx={{ marginLeft: 1 }}>
          {row.original.type}
        </Box>
      </>
    ),
  },
  {
    accessorKey: "order",
    header: ({ table }) => (
      <div
        style={{ display: "flex", alignItems: "center" }}
        onClick={() => {
          setSortBy("order");
          setIsDescending(!isDescending);
        }}
      >
        {" "}
        <Typography variant="body2">Position</Typography>
        {sortBy === "order" ? (
          isDescending == false ? (
            <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
          ) : (
            <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
          )
        ) : (
          <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
        )}{" "}
      </div>
    ),
    cell: ({ row }) => (
      <>
        <Box component="span" sx={{ marginLeft: 1 }}>
          {row.original.order}
        </Box>
      </>
    ),
  },
  {
    id: "edit",
    header: "",
    cell: ({ row }) => (
      <Button
        variant="raised"
        onClick={() => {
          handleEdit(row.original.id);
        }}
      >
        Edit
      </Button>
    ),
  },
  {
    id: "delete",
    header: "",
    cell: ({ row }) => (
      <Button
        variant="raised"
        onClick={() => {
          handleDelete(row.original);
        }}
      >
        <DeleteIcon />
      </Button>
    ),
  },
];
